import { useI18n } from "vue-i18n";

const STORAGE_KEY = "userLang";

export function useLanguage() {
  const { locale } = useI18n();

  async function saveLanguage(lang) {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      console.error("Failed to save language", e);
    }
  }

  function loadLanguage() {
    const savedLang = localStorage.getItem(STORAGE_KEY) || "bg";
    locale.value = savedLang;
  }

  async function changeLanguage(lang) {
    locale.value = lang;
    await saveLanguage(lang);
  }

  return {
    language: locale,
    changeLanguage,
    loadLanguage,
  };
}
